import { SelectedAddons, SelectedAddonInfo } from '../../state/types';

export type GroupedAddons = {
  [groupId: string]: {
    addonId: string;
    addon: SelectedAddonInfo;
  }[];
};

export const groupSelectedAddonsByGroupId = (
  selectedAddons: SelectedAddons | undefined,
): GroupedAddons => {
  if (!selectedAddons) {
    return {};
  }

  return Object.entries(selectedAddons).reduce<GroupedAddons>(
    (groups, [groupId, groupAddons]) => {
      groups[groupId] = Object.entries(groupAddons).map(([addonId, addon]) => ({
        addonId,
        addon,
      }));
      return groups;
    },
    {},
  );
};
